import { ThemeComponent } from '@/theme/ThemeComponent';
import { OptionSelector } from '@/utils/OptionSelectors';
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ProductOption } from '@/components/Product/ProductOptionPicker';

interface ValueRadio extends HTMLInputElement {
    dataset: {
        value: string;
    };
}

@Component
export class ProductButtonOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop values!: string[];
    @Prop selected!: string | null;
    @Prop position!: number;
    @Prop({ default: false }) isFrameset!: boolean;

    @Ref buttons!: ValueRadio[];
    @Ref({ required: false }) labelSelectedOption?: HTMLElement;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string | null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        this.bindButtonEvents();
        this._onChange.dispatch(this.selected);
        this.updateButtonStyles();
    }

    private bindButtonEvents() {
        for (const button of this.buttons) {
            this.$listen(button, 'change', () => {
                if (!button.checked) {return;}

                const value = button.value || null;
                this.select(value);

                // Update label selected value
                if (this.labelSelectedOption && value) {
                    this.labelSelectedOption.textContent = value.toLowerCase();
                }

                this._onChange.dispatch(value);
            });
        }
    }

    public select(value: string | null) {
        this.selected = value;
        this.updateButtonStyles();
    }

    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock)
            .map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists)
            .map((v) => v.value);

        this.updateButtonStyles();
    }

    public updateButtonStyles() {
        for (const button of this.buttons) {
            const value = button.value;
            const selected = (value || null) === this.selected;
            const outOfStock = this.valuesWithoutStock.includes(value);
            const noVariant = this.valuesWithoutVariant.includes(value);

            if (button.parentNode == null) { return; }

            const wrapper = button.parentNode as HTMLElement;
            if (selected) {
                wrapper.classList.add('product-form__button-item--active');
            } else {
                wrapper.classList.remove('product-form__button-item--active');
            }
            if (noVariant) {
                wrapper.classList.add('product-form__button-item--no-variant');
            } else {
                wrapper.classList.remove('product-form__button-item--no-variant');
            }
            if (outOfStock) {
                wrapper.classList.add('product-form__button-item--out-of-stock');
            } else {
                wrapper.classList.remove('product-form__button-item--out-of-stock');
            }

        }
    }
}
